<div [hidden]="!viewNotification" style="position: absolute; top: 10%; left: 0; width: 310px; z-index: 9999"></div>
<nav [class]="getNavbarClasses()">
  <div class="container-fluid mob-flex-v4">
    <div class="navbar-brand d-flex align-items-center" href="#">
      <img src="/assets/new-logo/SCBCLOGO-WHITE.svg" alt="Knowledge Gate" />
      <img src="/assets/new-logo/2030.png" alt="2030" />
    </div>
    <div class="{{!isLogin ? 'mx-3 d-flex justify-content-between' :'mx-3 mobile-d-none d-flex justify-content-between'}}" style="flex: 0.3 auto">

      <div class="hover-box" [hidden]="externalCoordinator?.status == true" [routerLink]="'/home'">
        <a class="hover-text">
          {{ "Homepage" | translator }}
        </a>
        <i class="pi pi-fw pi-home"></i>
      </div>

      <div class="hover-box" *ngIf="isLogin" [routerLink]="'/password-change'">
        <a class="hover-text">
          {{ "Password Reset" | translator }}</a>
          <i class="pi pi-fw pi-key"></i>
      </div>

      <div class="hover-box" *ngIf="isLogin" [hidden]="externalCoordinator?.status == true"
        [routerLink]="'/user-profile'">
          <a class="hover-text">
            {{ "Profile personly" | translator }}
          </a>
          <i class="pi pi-fw pi-user"></i>
      </div>

      <div class="hover-box" *ngIf="hasPermission('KNOWLEDGE_LIBRARY','r') || (!isLogin && hasOpenLibraryPermission())"
       [hidden]="externalCoordinator?.status == true" [routerLink]="'/knowledge-library'">
          <a class="hover-text">{{ "Knowledge Library" | translator }}
          </a>
          <i class="pi pi-fw pi-book"></i>
      </div>

      <div class="hover-box" *ngIf="hasPermission('CONTENT','r') || (!isLogin && hasOpenViewPermission())" [hidden]="externalCoordinator?.status == true"
        [routerLink]="'/all-data-view'">
        <a class="hover-text">{{ "Navigation page" | translator }}
        </a>
        <i class="pi pi-fw pi-list"></i>
      </div>

      <div class="hover-box" [routerLink]="'/permission-request-flow'">
        <a class="hover-text">
          {{ "Request permission" | translator }}
        </a>
        <i class="pi pi-fw pi-shield"></i>
      </div>

      <div
        class="hover-box"
        [hidden]="externalCoordinator?.status == true || productServiceCount <= 0"
        [routerLink]="'/products-view'"
      >
        <a class="hover-text">
          {{ "Products and Services" | translator }}
        </a>
        <i class="pi pi-fw pi-briefcase"></i>
      </div>


      <div class="hover-box" *ngIf="externalCoordinator.status != true && isLogin" (click)="navigateToFav()">
          <a class="hover-text">{{ "Favorite" | translator }}
          </a>
          <i class="fa-regular fa-star"></i>
      </div>

      <div class="hover-box" *ngIf="isLogin" (click)="handleLogout()">
          <a class="hover-text">
            {{ "Log out" | translator }}
          </a>
          <i class="pi pi-fw pi-sign-out"></i>
      </div>

      <div class="hover-box" *ngIf="!isLogin" (click)="handleLogout()">
        <a class="hover-text">
          {{ "Login" | translator }}
        </a>
        <i class="pi pi-fw pi-sign-in"></i>
      </div>

      <!-- <div *ngIf="externalCoordinator.status != true && isLogin" class="d-flex justify-content-center">
        <button (click)="navigateToFav()" class="btn color-white mx-2 font-0_8rem">
          <i *ngIf="getFavoriteCount() != '0'; else iconTemplate" class="fa-regular fa-star text-3xl star-size redd" pBadge
            severity="danger" [value]="getFavoriteCount()"></i>
          <ng-template #iconTemplate>
            <div class="pos-rel">
              <i class="fa-regular fa-star text-3xl star-size "></i>
            </div>
          </ng-template>
        </button>
      </div> -->


    </div>
    <div class="d-flex align-items-center">
    <div *ngIf="externalCoordinator.status != true && isLogin" class="d-flex justify-content-center">
      <button (click)="toggleNotificationPanel()"
        [attr.aria-label]="(newNotificationCount > 0 ? ('Notifications' | translator) : ('All caught up' | translator))"
        [attr.title]="(newNotificationCount > 0 ? null : ('All caught up' | translator))"
        [class]="newNotificationCount > 0 ? 'btn btn-bell' : 'btn btn-bell btn-bell-read'">
        <i *ngIf="newNotificationCount > 0; else iconTemplate" class="pi pi-bell text-3xl bell-size redd" pBadge
          severity="danger" [value]="newNotificationCount.toString()"></i>
        <ng-template #iconTemplate>
          <div class="pos-rel bell-read-wrap">
            <i class="pi pi-bell text-3xl bell-size bell-read-icon"></i>
            <span class="bell-read-check">
              <i class="pi pi-check"></i>
            </span>
          </div>
        </ng-template>
      </button>
    </div>
    <app-sidenav [hidden]="externalCoordinator?.status == true || !isLogin"></app-sidenav>
    </div>
  </div>
</nav>

<!-- <hr class="hr border-white" /> -->

<p-sidebar class="v4-left-p-sidebar" [(visible)]="viewNotification">
  <ng-template pTemplate="header">
    <span class="d-flex w-100">
      <img class="not-img" src="../../../assets/icons/SBC/speaker-vedios.svg" alt="loading" />
      <span class="not-head mx-2"> {{ "Notifications" | translator }}</span>
    </span>
  </ng-template>
  <ng-template pTemplate="content" class="p-0" style="padding: 0px">
    <div class="notify-scroll">
      <!-- <span class="clone-times" (click)="viewNotification = false;"><i class="pi pi-times"></i></span> -->
      <div class="notification">
        <div *ngFor="let notification of notifications" role="button" (click)="markSeen(notification)" class="d-flex align-items-center notification-row {{
            isSeen(notification)
              ? 'notification-box notification-row-read'
              : 'notification-box-active notification-row-unread'
          }}">
          <span *ngIf="!isSeen(notification)" class="notification-unread-dot"
            [attr.aria-label]="('Unread' | translator)"></span>
          <span *ngIf="isSeen(notification)" class="notification-read-check"
            [attr.aria-label]="('Read' | translator)">
            <i class="pi pi-check"></i>
          </span>
          <div>
            <img *ngIf="checkIsImage(notification.image); else elseBlock" class="notification-img"
              src="{{ staticFileUrl + notification.image }}" onerror="this.src='../../../assets/person-placeholder.jpg'"
              alt="loading" />
            <ng-template #elseBlock>
              <div class="notification-img d-center">
                <i class="{{ notification.image }}" style="font-size: 2rem"></i>
              </div>
            </ng-template>
          </div>
          <div class="column">
            <span class="{{
                isSeen(notification)
                  ? 'notification-label'
                  : 'notification-label-active'
              }}">{{ notification.title }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-label-deactive'
                  : 'notification-label-active'
              }}" style="font-weight: 500; font-size: 12px">{{ notification.name }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-text'
                  : 'notification-text-active'
              }}">{{ notification.message }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-date'
                  : 'notification-date-active'
              }}">{{ getDateDifference(notification.createdAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="w-100 v4-bg-bottom p-2 d-flex flex-column gap-2">
      <button *ngIf="newNotificationCount > 0" class="w-100 v4-left-nav-btn" (click)="markAllSeen()">
        <i class="pi pi-check-circle me-1"></i>
        {{ "markAllRead" | translator }}
      </button>
      <div *ngIf="hasPermission('VIEW_NOTIFICATIONS', 'a')">
        <button class="w-100 v4-left-nav-btn" routerLink="/notification">
          {{ "showAll" | translator }}
        </button>
      </div>
    </div>
  </ng-template>
</p-sidebar>